// extracted by mini-css-extract-plugin
export var textInput = "_dr-0";